window.wpbuoy = {}

import './index.scss';
import { initHeaderScroll, initNavDropdown } from './js/header.js';
import { initBuyNow } from './js/buy-now.js';
import './js/login.js';
import './js/account-forms.js';
import './js/cart.js';
import './js/modal.js';
import './js/faq.js';
import './js/contact.js';
import './js/checkout-password.js';
import './js/registration-password.js';
import './js/order-highlight.js';
import './js/copy-code.js';
import './js/support.js';

var canvas = document.querySelector('#hero canvas')
if (canvas) {
  
  var context = canvas.getContext('2d')
  var bubbles = []

  canvas.width = screen.width
  canvas.height = screen.height

  for( i = 0; i < 150; i++ ) {
    let diameter = ( Math.ceil( Math.random() * 7 ) )
    let radius = diameter / 2
    let opacity = diameter * .035
    let speed = diameter * .3
    let x = Math.round( ( Math.floor( ( Math.random() * ( 100 - 0 ) ) + 0 ) ) * screen.width ) / 100
    let y = Math.round( ( Math.floor( ( Math.random() * ( 200 - 90 ) ) + 90 ) ) * screen.height ) / 100
    let amplitude = (Math.random() * .3 ) + .3
    bubbles.push({
      amplitude: amplitude,
      radius: radius,
      opacity: opacity,
      speed: speed,
      x: x,
      y: y,
      initialX: x,
      initialY: y
    })
  }

  function animateParticles() {

    requestAnimationFrame( animateParticles )
    context.clearRect( 0, 0, innerWidth, innerHeight )
    for( let i = 0; i < bubbles.length; i++ ) {
      let bubble = bubbles[i]

      if( bubble.y < 0 ) {
        bubble.x = bubble.initialX
        bubble.y = bubble.initialY
      }

      context.beginPath()
      context.arc( bubble.x, bubble.y, bubble.radius, 0, 2 * Math.PI )
      context.closePath()
      context.stroke()
      context.strokeStyle = 'rgba(255, 255, 255, ' + bubble.opacity + ')'

      bubble.y += document.documentElement.scrollTop == 0 ? -bubble.speed : ( -bubble.speed * ( document.documentElement.scrollTop / 100 ) )
      bubble.x = bubble.x + Math.sin( i / bubble.amplitude ) * .3;
    }
  }
  animateParticles()
}

// Initialize header scroll effects with Intersection Observer
document.addEventListener('DOMContentLoaded', function() {
  initHeaderScroll();
  initNavDropdown();
  initBuyNow();
});
